import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { capitalize } from 'lodash';
import { Company } from '@/pages/Stocks/components/StockTiles/Tile';

type SectionRedirectTextParams = {
  section: CompanyReportSection;
  industry: string;
  market: string;
};

export const getIdeanameBySection = (section: CompanyReportSection) => {
  const SECTIONS_IDEANAME_MAP = {
    valuation: 'potentially-undervalued-companies',
    future: 'high-growth-potential-companies',
    past: 'sustainable-track-record',
    health: 'healthy-companies',
    dividend: 'top-dividend-stocks',
  };

  return SECTIONS_IDEANAME_MAP[section];
};

export const getRedirectTextBySection = ({
  section,
  industry,
  market,
}: SectionRedirectTextParams) => {
  const industryText = capitalize(industry);
  const marketText = market.toUpperCase();

  const SECTIONS_REDIRECT_TEXT_MAP = {
    valuation: `Potentially undervalued companies in the ${industryText} industry`,
    future: `High growth companies in the ${industryText} industry`,
    past: `Strong past performing companies in the ${industryText} industry`,
    health: `Healthy companies in the ${industryText} industry`,
    dividend: `Strong dividend paying companies in the ${marketText} market`,
  };

  return SECTIONS_REDIRECT_TEXT_MAP[section];
};

export const getTop4Companies = (
  companies: Company[],
  currentCompanyId: string
) => {
  return companies
    .filter(
      (company) =>
        company.companyId?.toLowerCase() !== currentCompanyId?.toLowerCase()
    )
    .slice(0, 4);
};
